export default __webpack_public_path__ + "static/media/more.8b5fdb40.png";